import React from 'react'
import HeroSection from './Components/HeroSection'
import './Portfolio.css'
import PortfolioWork from './Components/PortfolioWork'
const Portfolio = () => {
  return (
    <div>
        <HeroSection/>
        <PortfolioWork/>
    </div>
  )
}

export default Portfolio